export const FormSelectContractName = 'contract';

export enum SelectContractFormFields {
  ContractId = 'contractId',
}
